export const DEBUG_STORE_KEY = 'DEBUG_STORE';
